import { GetterTree } from 'vuex';
import { RootState } from '../../models/RootState';
import {
  OrderlineState,
  Orderline,
  OrderlineDetails,
  OrderPo,
  CustomerOrder
} from '@/store/models/OrderlineModel';
import { state } from '../profile';
import { Customer } from '@/store/models/CustomerModel';
export const getters: GetterTree<OrderlineState, RootState> = {
  orderlines(state): Orderline[] {
    const { orderlines } = state;
    if (orderlines) {
      // return [...orderlines.filter(o => o.Page === state.currentPage).values()];
      return [...orderlines.filter(o => o.Id).values()];
    }
    return [];
  },
  isPlacingOrder(state): boolean {
    return state.isPlacingOrder;
  },
  queuedItems(state): Orderline[] {
    const { queuedOrderlines } = state;
    if (queuedOrderlines) {
      return [...queuedOrderlines.values()];
    }
    return [];
  },
  hasOrderlines(state): boolean {
    return state.hasOrderlines;
  },
  onHoldOrderlines(state): Orderline[] {
    const { onHoldOrderlines } = state;
    if (onHoldOrderlines) return [...onHoldOrderlines.values()];
    return [];
  },
  orderlineProofs(state): Orderline[] {
    const { orderlineProofs } = state;
    if (orderlineProofs) return [...orderlineProofs.values()];
    return [];
  },
  orderlinesWithInvoice(state): Orderline[] {
    const { orderlinesWithInvoice } = state;
    if (orderlinesWithInvoice) return [...orderlinesWithInvoice.values()];
    return [];
  },
  pendingOrderlines(state): Orderline[] {
    const { pendingOrderlines } = state;
    if (pendingOrderlines) return [...pendingOrderlines.values()];
    return [];
  },
  recentlyShippedOrderlines(state): Orderline[] {
    const { recentlyShippedOrderlines } = state;
    if (recentlyShippedOrderlines) return [...recentlyShippedOrderlines.values()];
    return [];
  },
  getCurrentPage(state): number {
    const { currentPage } = state;
    if (currentPage) {
      return currentPage;
    }
    return 1;
  },
  getOrderlineCounts(
    state
  ): {
    allOrderlinesCount: number;
    inProductionCount: number;
    inTransitCount: number;
  } {
    const { allOrderlinesCount, inProductionCount, inTransitCount } = state;
    return { allOrderlinesCount, inProductionCount, inTransitCount };
  },
  getLoadingState(state): boolean {
    const { isLoading } = state;
    return isLoading || false;
  },
  getOrderPos(state): OrderPo[] {
    const { pos } = state;
    if (pos) {
      return pos;
    }
    return [];
  },
  getSearchedOrderlines(state): Orderline[] {
    const { filteredOrderlines } = state;
    if (filteredOrderlines) {
      return filteredOrderlines;
    }
    return [];
  },
  getOrderSearchContent(state): string[] {
    const { orderSearch } = state;
    if (orderSearch) {
      return [...orderSearch.values()];
    }
    return [];
  },
  getPaginationStatus(state): boolean {
    const { isDonePaginating } = state;
    return isDonePaginating;
  },
  getShoppingCart(state): CustomerOrder {
    const { shoppingCart } = state;
    return shoppingCart;
  }
};
